export default (value) => {
  if (!value) return ''
  value = value.toString()
  return value.toLowerCase()
}



// WEBPACK FOOTER //
// ./src/filters/lowercase.js